import { useEffect, useState } from "react";
import { getService, PostService } from "../GenericServices/genericService";

const ViewOrderModal = ({ viewingOrder, setShowOrderModal }) => {
  /* States */

  const [orderDetails, setOrderDetails] = useState({});
  const [orderItems, setOrderItems] = useState([]);

  useEffect(() => {
    if (viewingOrder) {
      console.log("Viewing Order:", viewingOrder);
      viewOrderAPI(viewingOrder.order_id);
    }
  }, [viewingOrder]);

  /* View Order API */
  const viewOrderAPI = (orderId) => {
    let data = {
      order_id: +orderId,
    };
    const url = "myNewAPI/view_order.php";
    getService(url, data, getData);
  };

  const getData = (response) => {
    console.log("Responseasdasd", response);
    setOrderItems(response.order_items);
    setOrderDetails(response.orders);
  };

  const getOrderStatus = (status) => {
    switch (status) {
      case "1":
        return "Pending";
      case "2":
        return "Processing";
      case "3":
        return "Shipped";
      case "4":
        return "Delivered";
      case "5":
        return "Cancelled";
      default:
        return status;
    }
  };

  return (
    <>
      <div className="fixed inset-0 bg-black bg-opacity-50 z-[100] flex items-center justify-center p-2 sm:p-4">
        <div className="bg-white rounded-lg p-4 sm:p-6 w-full max-w-2xl max-h-[90vh] overflow-y-auto">
          <div className="flex justify-between items-start mb-4">
            <h2 className="text-xl sm:text-2xl font-bold">Order Details</h2>
            <button
              onClick={() => setShowOrderModal(false)}
              className="text-gray-500 hover:text-gray-700 text-xl"
            >
              ✕
            </button>
          </div>
          {orderDetails && Object.keys(orderDetails).length > 0 ? (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
              <div>
                <h3 className="text-lg font-semibold mb-2">
                  Customer Information
                </h3>
                <p>
                  <strong>Name: </strong> <br />
                  {orderDetails.customer_name}
                </p>
                <p>
                  <strong>Email: </strong> <br />
                  {orderDetails.customer_email}
                </p>
                <p>
                  <strong>Address: </strong> <br />
                  {orderDetails.customer_address + ", " + orderDetails.city}
                </p>
              </div>
              <div>
                <h3 className="text-lg font-semibold mb-2">
                  Order Information
                </h3>
                <p>
                  <strong>Order ID: </strong> <br />
                  {orderDetails.order_id}
                </p>
                <p>
                  <strong>Status: </strong> <br />
                  {getOrderStatus(orderDetails.status_id)}
                </p>
                <p>
                  <strong>Date: </strong> <br />
                  {new Date(orderDetails.created_at).toLocaleString()}
                </p>
                <p>
                  <strong>Total: </strong> <br />
                  PKR{" "}
                  {new Intl.NumberFormat("en-IN").format(orderDetails.total)}
                </p>
              </div>
            </div>
          ) : (
            <p className="text-center py-4">No order details available.</p>
          )}
          <div>
            <h3 className="text-lg font-semibold mb-2">Customer Order Items</h3>
            <div className="space-y-2">
              {orderItems &&
                orderItems.length > 0 &&
                orderItems.map((item, index) => (
                  <div
                    key={index}
                    className="flex flex-col sm:flex-row justify-between items-start sm:items-center border-b pb-2"
                  >
                    <div className="flex items-center mb-2 sm:mb-0">
                      <img
                        src={`../myNewAPI/${item.prod_img}`}
                        alt={item.prod_name}
                        className="h-16 w-16 sm:h-28 sm:w-auto object-cover mr-4 rounded flex-shrink-0"
                      />
                      <div>
                        <p className="font-medium">{item.prod_name}</p>
                        <p className="text-sm text-gray-600">
                          Qty: {item.product_quantity}
                        </p>
                      </div>
                    </div>
                    <p className="font-medium">
                      PKR{" "}
                      {new Intl.NumberFormat("en-IN").format(item.prod_price)}
                    </p>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewOrderModal;
